module.exports = __webpack_public_path__ + "img/symbol_s14.c051ce2.svg";